import { StatusInfoResponse } from '../api/ph-web/delivery/delivery.api_pb';
import { MuExceptionCode } from '../models/interface/muExceptionCode.enum';
import { MuExceptionData } from '../models/interface/muExceptionData.interface';

export class MuException {
  private muExceptionData: MuExceptionData;

  constructor(muException: MuExceptionData) {
    this.muExceptionData = muException;
  }

  /**
   * get code
   * @returns {MuExceptionCode} response
   */
  get code(): MuExceptionCode | StatusInfoResponse.ErrorCode {
    return this.muExceptionData?.code;
  }

  /**
   * get code
   * @returns {string} response
   */
  get key(): string {
    return this.muExceptionData?.key;
  }

  /**
   * get message
   * @returns {string} response
   */
  get message(): string {
    return this.muExceptionData?.message;
  }

  /***
   * force message
   * @returns {boolean} response
   */
  get forceMessage(): boolean {
    return this.muExceptionData?.forceMessage;
  }

  /**
   * control name
   * @returns {string} response
   */
  get controlName(): string {
    return this.muExceptionData?.controlName;
  }
}
